import { ParsedDoc } from '../types';
import { extractHeadings } from './extract-headings';
import { parseFrontmatter } from './parse-frontmatter';

const rawDocs = import.meta.glob('../content/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

// Repo-root changelog, so the docs page stays in sync without a second copy under content/.
const changelogFiles = import.meta.glob('../../../../CHANGELOG.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const docsBySlug: Record<string, ParsedDoc> = {};

for (const [path, raw] of Object.entries(rawDocs)) {
  try {
    const { frontmatter, body } = parseFrontmatter(raw);
    docsBySlug[frontmatter.slug] = {
      frontmatter,
      body,
      headings: extractHeadings(body),
    };
  } catch (error) {
    console.error(`Failed to parse doc at ${path}:`, error);
  }
}

const changelogBody = Object.values(changelogFiles)[0]?.trim();

if (changelogBody) {
  docsBySlug.changelog = {
    frontmatter: {
      title: 'Changelog',
      slug: 'changelog',
      section: 'Release notes',
      order: 1,
      description: 'What shipped in each release.',
    },
    body: changelogBody,
    // "Added" / "Fixed" repeat on every release, so the outline lists versions only.
    headings: extractHeadings(changelogBody).filter((heading) => heading.level === 2),
  };
}

export function getAllDocs(): ParsedDoc[] {
  return Object.values(docsBySlug).sort((a, b) => a.frontmatter.order - b.frontmatter.order);
}

export function getDocBySlug(slug: string): ParsedDoc | undefined {
  return docsBySlug[slug];
}
